var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('StatusPill',{attrs:{"color":_vm.statusColors[_vm.client.status],"label":_vm.statusLabels[_vm.client.status]}})
}
var staticRenderFns = []

export { render, staticRenderFns }